import React from 'react';
import { observer } from 'mobx-react';
import { Check } from '@mui/icons-material';
import {
  List, ListItem, ListItemIcon, ListItemText,
} from '@mui/material';

const TierBenefits: React.FC<{
  benefits: {
    content: React.ReactNode,
    subContent?: React.ReactNode
  }[]
}> = observer(({ benefits }) => (
  <List>
    {
      benefits.map(({
        content,
        subContent,
      }) => (
        <ListItem
          sx={{
            paddingInline: 1,
            py: 0,
          }}
        >
          <ListItemIcon
            sx={{
              justifyContent: 'center',
              minWidth: '3rem',
            }}
          >
            <Check
              sx={{
                color: 'primary.main',
                fontSize: 20,
              }}
            />
          </ListItemIcon>
          <ListItemText
            sx={{ position: 'relative' }}
            primaryTypographyProps={{ sx: { fontSize: 13 } }}
            primary={content}
          />
          <ListItemText
            primaryTypographyProps={{
              sx: {
                fontSize: 13,
              },
            }}
            primary={subContent}
          />
        </ListItem>
      ))
    }
  </List>
));

export default TierBenefits;
